"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomResponseOptionTable = exports.HeaderUnstyled = void 0;
var aon_tws_common_ui_1 = require("@aon/aon-tws-common-ui");
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var contentConstants_1 = __importDefault(require("../../../contentConstants"));
var models_1 = require("../../../models");
var utilities_1 = require("../../../utilities");
var common_1 = require("../../common");
var CustomResponseOptionRow_1 = require("./CustomResponseOptionRow");
exports.HeaderUnstyled = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tfont-weight: normal;\n\ttext-transform: none;\n\tline-height: 1.5em;\n"], ["\n\tfont-weight: normal;\n\ttext-transform: none;\n\tline-height: 1.5em;\n"])));
var AddButtonContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tmargin-left: 20px;\n\tmargin-top: 10px;\n"], ["\n\tmargin-left: 20px;\n\tmargin-top: 10px;\n"])));
var AddButtonText = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t", "\n\tpadding-left: 10px;\n"], ["\n\t", "\n\tpadding-left: 10px;\n"])), aon_tws_common_ui_1.bodyCopySmall);
var CustomResponseOptionTable = /** @class */ (function (_super) {
    __extends(CustomResponseOptionTable, _super);
    function CustomResponseOptionTable(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        _this.toggleExpand = _this.toggleExpand.bind(_this);
        _this.onSortingChange = _this.onSortingChange.bind(_this);
        return _this;
    }
    CustomResponseOptionTable.getDerivedStateFromProps = function (props) {
        var validationHelper = new utilities_1.ValidationHelper(props.validationResult);
        return {
            roLabelValidationResult: validationHelper.GetValidationResultForProperty(models_1.CustomQuestionPropertyUnderValidation.responseOptionLabel),
            roValueValidationResult: validationHelper.GetValidationResultForProperty(models_1.CustomQuestionPropertyUnderValidation.responseOptionValue),
        };
    };
    CustomResponseOptionTable.prototype.toggleExpand = function (id) {
        if (this.state.openResponseOptionId === id) {
            this.setState({ openResponseOptionId: undefined });
        }
        else {
            this.setState({ openResponseOptionId: id });
        }
    };
    CustomResponseOptionTable.prototype.onSortingChange = function (itemIds) {
        var ids = itemIds.map(function (id) { return parseInt(id, 10); });
        this.props.UpdateCustomResponseOptionsOrder(ids);
    };
    CustomResponseOptionTable.prototype.render = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement(common_1.FormattedTable, { leftMargin: 60, className: 'tws-custom-response-options-table' },
                this.props.responseOptions.length > 0 && (React.createElement(common_1.FormattedHeaderRow, null,
                    React.createElement(common_1.FormattedTh, { flexBasis: 55 }, contentConstants_1.default.CUSTOM_RESPONSEOPTION_HEADER_LABEL),
                    this.props.responseOptions[0].translations.length > 1 && (React.createElement(common_1.FormattedTh, { flexBasis: 20 }, contentConstants_1.default.CUSTOM_RESPONSEOPTION_HEADER_TRANSLATIONS)),
                    React.createElement(common_1.FormattedTh, { flexBasis: 15 },
                        contentConstants_1.default.CUSTOM_RESPONSEOPTION_HEADER_VALUE,
                        React.createElement(exports.HeaderUnstyled, null,
                            React.createElement(aon_tws_common_ui_1.Tooltip, { id: 'response-option-value-header-tooltip', contentType: 'html' },
                                React.createElement("strong", null, contentConstants_1.default.CUSTOM_RESPONSEOPTION_HEADER_VALUE_TOOLTIP_TITLE),
                                React.createElement("br", null),
                                React.createElement("br", null),
                                contentConstants_1.default.CUSTOM_RESPONSEOPTION_HEADER_VALUE_TOOLTIP_TEXT))),
                    this.props.isFollowUpEnabled && (React.createElement(common_1.FormattedTh, { flexBasis: 15 },
                        contentConstants_1.default.CUSTOM_RESPONSEOPTION_HEADER_FOLLOW_UP,
                        React.createElement(exports.HeaderUnstyled, null,
                            React.createElement(aon_tws_common_ui_1.Tooltip, { id: 'response-option-follow-up-header-tooltip', contentType: 'html' },
                                React.createElement("strong", null, contentConstants_1.default.CUSTOM_RESPONSEOPTION_HEADER_FOLLOW_UP_TOOLTIP_TITLE),
                                React.createElement("br", null),
                                React.createElement("br", null),
                                contentConstants_1.default.CUSTOM_RESPONSEOPTION_HEADER_FOLLOW_UP_TOOLTIP_TEXT)))),
                    React.createElement(common_1.FormattedTh, { flexBasis: 10 }))),
                React.createElement(common_1.SortableTBody, { onChange: this.onSortingChange, items: this.props.responseOptions, disabled: this.state.openResponseOptionId != null }, this.props.responseOptions.map(function (r, key) { return (React.createElement(CustomResponseOptionRow_1.CustomResponseOptionRow, __assign({ responseOption: r, key: r.id, disabled: _this.state.openResponseOptionId != null }, _this.props, { index: key, ToggleExpand: _this.toggleExpand, errorMessages: _this.getErrorMessage(key), deleteDisabled: _this.props.responseOptions.length <= _this.props.minimumResponseOptions, isExpanded: _this.state.openResponseOptionId === r.id }))); }))),
            React.createElement(AddButtonContainer, null,
                React.createElement(aon_tws_common_ui_1.Button, { size: 'xs', floating: true, className: 'tws-add-response-option-button', onClick: this.props.AddResponseOption },
                    React.createElement(aon_tws_common_ui_1.Icon, { name: 'add' })),
                React.createElement(AddButtonText, null, contentConstants_1.default.CUSTOM_RESPONSEOPTION_ADD_TEXT))));
    };
    CustomResponseOptionTable.prototype.getErrorMessage = function (index) {
        var roValueValidationResult = this.state.roValueValidationResult;
        var roLabelValidationResult = this.state.roLabelValidationResult;
        var valuePropertyErrors = roValueValidationResult && roValueValidationResult.propertyErrors ? roValueValidationResult.propertyErrors : undefined;
        var labelPropertyErrors = roLabelValidationResult && roLabelValidationResult.propertyErrors ? roLabelValidationResult.propertyErrors : undefined;
        var messages = [];
        messages = valuePropertyErrors && valuePropertyErrors[index] ? valuePropertyErrors[index] : [];
        messages = labelPropertyErrors && labelPropertyErrors[index] ? messages.concat(labelPropertyErrors[index]) : messages;
        return messages;
    };
    return CustomResponseOptionTable;
}(React.PureComponent));
exports.CustomResponseOptionTable = CustomResponseOptionTable;
var templateObject_1, templateObject_2, templateObject_3;
